var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ar-simple-button',{staticClass:"ar-lock-simple-button",attrs:{"icon-name":"lock","icon-props":{
    width: '14px',
  },"text":_vm.text,"shape":_vm.shape,"type":_vm.type,"outlined":_vm.outlined,"transparent":_vm.transparent,"icon-distance":"10px"},nativeOn:{"click":function($event){return _vm.handleButtonClick.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }